<template>
  <b-container fluid>
    <b-row class="mx-auto">
      <Practicienne
        v-for="practicienne in practiciennes"
        :key="practicienne.firstname"
        :firstname="practicienne.firstname"
        :surname="practicienne.surname"
        :formation="practicienne.formation"
        :picture="practicienne.picture"
        :skills="practicienne.skills"
        :location="practicienne.location"
        :text="practicienne.text"
        :link="practicienne.link"
        >{{ practicienne.text }}</Practicienne
      >
    </b-row>
  </b-container>
</template>

<script>
import Practicienne from "../components/Practicienne";

export default {
  data() {
    return {
      practiciennes: [
        {
          picture: "image36.jpg",
          firstname: "Agnès",
          surname: "Beille",
          skills:
            "Je suis les personnes présentant tout type de handicap : moteur, polyhandicap, troubles neurodéveloppementaux, troubles spécifiques des apprentissages… Je travaille en lien avec les différents intervenants de chaque patient.",
          formation:
            "Certificat de capacité d’Orthoptiste, faculté de Montpellier, DU Neuro-Ophtalmologie, DU Neuropsychopathologie des apprentissages scolaires, Formation PECS/ABA.",
          location: "St Martin d'Hères",
          link: "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/agnes-beille#cabinet-13615",
          text:
            "J’effectue essentiellement des rééducations neurovisuelles enfants et adultes.",
        },
        {picture: "image34.jpg",
        firstname: "Lisa",
        surname: "Bertrand",
        link: "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/lisa-bertrand#cabinet-13615",
        skills: "La prise en charge de l'insuffisance de convergence chez les enfants et adultes.",
        formation: "Certificat de capacité d'orthoptiste, diplômée de l'école de Lyon",
        location: "St Martin d'Hères",
        text: "J'effectue les rééducations des déséquilibres de la vision binoculaire et les contrôles de correction optique. Je prend également en charge les troubles d'apprentissages, strabismes, amblyopies et paralysies oculomotrices." },
        {
          picture: "image15.jpg",
          firstname: "Isabelle",
          surname: "Cheymol",
          formation:
            "Certificat de capacité d’orthoptiste, faculté de Clermont Ferrand, DU neuropsychologie des apprentissages scolaires, formation neurovision",
          location: "St Martin d'Hères",
          link:
            "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/isabelle-cheymol#cabinet-13615",
          skills:
            "Les strabismes, les prises en charges des patients polyhandicapés et autistes. Je réalise également les examens de dépistage de la rétinopathie diabétique.",
          text:
            "Je réalise tout type de prise en charge (dépistage visuel, strabisme, amblyopie, paralysie oculomotrice, suivi dans le cadre de troubles d’apprentissages, neurovision enfant et adulte).",
        },
        {
          picture: "image16.jpg",
          firstname: "Anne ",
          surname: "Gallasso",
          link:
            "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/anne-gallasso#cabinet-13615",
          formation:
            "Certificat de capacité d’orthoptiste, faculté de Lyon. 10 ans d’expérience en préconsultation ophtalmologique.",
          location: "St Martin d'Hères",
          skills:
            "Les patients basse vision adultes, les examens de vue et les renouvellement de lunettes.",
          text:
            "Je prends en charge les rééducations de vision binoculaire, les suivis d’amblyopie, de strabisme, de paralysie et les troubles d’apprentissages. Je travaille en lien avec les différents intervenants de chaque patient.",
        },
        {
          picture: "image22.jpg",
          firstname: "Camille",
          surname: "Masson",
          skills: "La rééducation des troubles vestibulaires (vertiges)",
          link:
            "https://www.keldoc.com/orthoptiste/st-martin-d-heres-38400/camille-masson#cabinet-13615",
          formation:
            "Certificat de capacité d’orthoptiste, faculté de Lyon. DU Exploration rééducation des troubles de l’équilibre.",
          location: "St Martin d'Hères",
          text:
            "Je prends en charge les rééducations de vision binoculaire, les suivis d’amblyopie, de strabisme, paralysie et troubles d’apprentissages. Je réalise également les examens de vue (réfraction) et le dépistage de la rétinopathie diabétique. Je travaille en lien avec les différents intervenants de chaque patient.",
        }
      ],
    };
  },
  components: {
    Practicienne,
  },
};
</script>

<style scoped>
img {
  margin-top: 80px;
  margin-bottom: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  width: 100%;
}
</style>
